import React, { useState, Fragment, useEffect } from "react";
import useRenderCount from "../../renderCountHook";
import DropDown from "../../components/DropDown/dropdown";
import TextInput from "../../components/TextInput/textInput";
import Button from "../../components/Button/button";
import StringConstant from '../../stringConstant'
import { useTranslation } from "react-i18next";

const PreOwnedCar = ({ usedCarYearList, usedCarMakeList, isSendDeliveryBroadcast = null, activeTab, historyData = null }) => {
   useRenderCount("SELECT VEHICLE--PRE_OWNED")
   const [carYear, setCarYear] = useState();
   const [carMake, setCarMake] = useState();
   const [carModel, setCarModel] = useState();
   const [carStyle, setCarStyle] = useState();
   const { t } = useTranslation();

   useEffect(() => {
      if (historyData && historyData.carYear) {
         setCarYear(historyData.carYear);
         setCarMake(historyData.carMake);
         setCarModel(historyData.carModel);
         setCarStyle(historyData.carStyle);

         localStorage.removeItem('postData');
      }
   }, [historyData])

   useEffect(() => {
      let dataToSave = {
         carYear: carYear,
         carMake: carMake,
         carModel: carModel,
         carStyle: carStyle
      }
      localStorage.setItem('postData', JSON.stringify(dataToSave))
   }, [carYear, carMake, carModel, carStyle])

   return (
      <Fragment>
         <div className="ddList">
            <div className="h-100 justify-content-center align-items-center">
               <div className="">
                  <DropDown ddclassName="box-0" list={usedCarYearList}
                     value={JSON.stringify(carYear)}
                     onChange={e => {
                        setCarYear(JSON.parse(e.target.value));
                        setCarMake(null)
                     }}
                  />
                  <DropDown ddclassName="box-1" list={usedCarMakeList}
                     value={JSON.stringify(carMake)}
                     onChange={e => {
                        setCarMake(JSON.parse(e.target.value));
                     }}
                  />
                  <TextInput name="model" title={t(StringConstant.labelModel)} type="text"
                     value={carModel}
                     onChange={(e) => setCarModel(e.target.value)}
                  />
                  <TextInput name="style" title={t(StringConstant.labelStyle)} type="text"
                     value={carStyle}
                     onChange={(e) => setCarStyle(e.target.value)}
                  />

                  <div className='next_fixed_btn'>
                     { (carYear && carMake && carModel && carStyle) && <Button to={"/optionalPhoto"} navData={{ activeTab, carMake, carYear, carModel, carStyle, isSendDeliveryBroadcast }} title={t(StringConstant.labelNext)} />}

                  </div>


               </div>
            </div>
         </div>

         </Fragment>
   )
}

export default PreOwnedCar
